import moment from 'moment'
import { validaData } from './ValidationUtils'

export const stringToDate = (value: any) => {
  // 0 1 / 0 1 / 0 1 0 1
  // 0 1 2 3 4 5 6 7 8 9
  if (value && validaData(value)) {
    return new Date(
      parseInt(String(value).substr(6, 4)),
      parseInt(String(value).substr(3, 2)) - 1,
      parseInt(String(value).substr(0, 2))
    )
  }
  return null
}

export const dateToString = (date: any) => {
  try {
    const d = moment(date)
    return d.format('DD/MM/YYYY')
  } catch (err) {
    console.error(err)
    return ''
  }
}

const getTwoNumbersIfNotTen = (num: number) => {
  if (String(num).length < 2) return `0${num}`
  return String(num)
}

export const secondsToHours = (seconds: number) => {
  if (seconds <= 0) return '00:00:00'
  const h = Math.floor(seconds / 3600)
  const hh = getTwoNumbersIfNotTen(h)
  const m = Math.floor((seconds - h * 3600) / 60)
  const mm = getTwoNumbersIfNotTen(m)
  const s = getTwoNumbersIfNotTen(seconds - h * 3600 - m * 60)
  return hh.concat(':').concat(mm).concat(':').concat(s)
}
